import { jsx } from "react/jsx-runtime";
import { isOutputState, isCallState } from "./types.js";
import { StoreLocatorWidget } from "../StoreLocatorWidget/index.js";
function StoreLocatorPart({
  part,
  apiBaseUrl,
  mergedSkus
}) {
  var _a;
  if (isCallState(part.state)) {
    return /* @__PURE__ */ jsx("div", { className: "concierge-loading", style: { padding: "12px 0", fontSize: "14px" }, children: "Finding nearby stores..." });
  }
  if (isOutputState(part.state) && part.output) {
    if (part.output.error) {
      return null;
    }
    if (part.output.isOnlineOnly) {
      return null;
    }
    const skus = mergedSkus ?? part.output.stacklineSkus ?? [];
    const requestedLocation = part.output.requestedLocation ?? ((_a = part.input) == null ? void 0 : _a.requestedLocation);
    if (part.output.hasStores && skus.length > 0) {
      return /* @__PURE__ */ jsx(
        StoreLocatorWidget,
        {
          stacklineSkus: skus,
          apiUrl: apiBaseUrl,
          initialLocation: requestedLocation
        }
      );
    }
    return null;
  }
  return null;
}
function getMergedStoreLocatorInfo(allParts) {
  const storeLocatorParts = [];
  allParts.forEach((p, i) => {
    if (p.type !== "tool-show_store_locator") return;
    const slPart = p;
    if (!isOutputState(slPart.state)) return;
    const output = slPart.output;
    if (!output || output.error || output.isOnlineOnly || !output.hasStores) return;
    const skus = output.stacklineSkus ?? [];
    if (skus.length > 0) {
      storeLocatorParts.push({ index: i, skus });
    }
  });
  if (storeLocatorParts.length <= 1) return null;
  const allSkus = [...new Set(storeLocatorParts.flatMap((p) => p.skus))];
  return { renderIndex: storeLocatorParts[storeLocatorParts.length - 1].index, allSkus };
}
export {
  StoreLocatorPart,
  getMergedStoreLocatorInfo
};
//# sourceMappingURL=StoreLocatorPart.js.map
